import { render, staticRenderFns } from "./obs-department-detail.vue?vue&type=template&id=8f8bedae&"
import script from "./obs-department-detail.vue?vue&type=script&lang=js&"
export * from "./obs-department-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports